/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MenuItemMapStockEntity { 
    creator?: string;
    modifier?: string;
    createdAt?: Date;
    modifiedAt?: Date;
    menuItemStockMapId?: string;
    menuItemMapId?: string;
    restaurantId?: string;
    restaurantBranchId?: string;
    totalQuantity?: number;
    availableQuantity?: number;
    reservedQuantity?: number;
    stockCheckEnabled?: boolean;
    resetStockDaily?: boolean;
    date?: Date;
    active?: boolean;
}